<template>
  <div class="overflow: auto">
    <a href="/api/v1/product/export">
      <Button type="primary" style="display: block; margin: auto">导出</Button>
    </a>

    <!-- <img src="../assets/YTNSOZPZ45823592.jpg" alt="" srcset=""> -->
    <Table :content="self" border stripe :columns="columns1" :data="data1" ref="table">
      <template slot-scope="{ row, index }" slot="action">
        <div
          @click="Config(row)"
          style="color: #409eff; cursor: pointer"
        >{{ Math.floor(row.rewardAmount * row.userProductRate) }}/修改</div>
      </template>
      <template slot-scope="{ row, index }" slot="QRCode">
        <Button
          type="primary"
          style="display: block; margin: auto"
          @click="
            thisIndex = index;
            modal2 = true;
            creatQrCode(row, index);
          "
        >生成推广二维码和和链接</Button>
        <div class="qrcode" :id="'qrcode' + index" :ref="'qrCodeUrl' + index"></div>
      </template>
    </Table>
    <Modal width="350" height="600" v-model="modal2" title="二维码和链接">
      <div v-if="data1[thisIndex]">链接：{{ data1[thisIndex].applyUrl }}</div>
      <img :id="'base64' + thisIndex" />
    </Modal>
    <Modal width="15" v-model="modal1" title="设置团队金额" @on-ok="userProductRate">
      代理比例：
      <Input v-model="proportion" style="width: auto; margin-right: 15px" />%
    </Modal>
    <br />
    <Page :total="total" @on-change="pagingSuery" show-elevator />
  </div>
</template>

<script>
import { api } from "../biz/api";
import QRCode from "qrcodejs2";
export default {
  name: "Product",

  data() {
    return {
      modal1: false,
      total: 0,
      modal2: false,
      thisIndex: 0,
      time: [],
      proportion: "",
      slaveTotal: "",
      phone: "",
      ConfigData: "",
      self: this,
      keyword: "",
      pageNow: 1,
      columns1: [
        {
          title: "id",
          align: "center",
          key: "id"
        },
        {
          title: "产品",
          align: "center",
          key: "productName"
        },

        {
          title: "结算时间",
          align: "center",
          key: "settlementCycle"
        },
        {
          title: "结算规则",
          align: "center",
          key: "settlementRules"
        },

        {
          title: "推广海报/链接",
          align: "center",
          key: "applyUrl",
          slot: "QRCode",
          width: 250
        },
        {
          title: "总金额/元",
          align: "center",
          key: "rewardAmount"
        },
        {
          title: "降级金额/元",
          align: "center",
          key: "demotedAmount"
        },
        {
          title: "额外金额/元",
          align: "center",
          key: "extraAmount"
        },
        {
          title: "设置团队金额",
          key: "address",
          align: "center",
          slot: "action"
        }
      ],
      columns2: [
        {
          title: "id",
          align: "center",
          key: "id"
        },
        {
          title: "产品",
          align: "center",
          key: "productName"
        },

        {
          title: "结算时间",
          align: "center",
          key: "settlementCycle"
        },
        {
          title: "结算规则",
          align: "center",
          key: "settlementRules"
        },

        {
          title: "推广海报/链接",
          align: "center",
          key: "applyUrl",
          slot: "QRCode",
          width: 250
        },
        {
          title: "总金额/元",
          align: "center",
          key: "rewardAmount"
        },
        {
          title: "降级金额/元",
          align: "center",
          key: "demotedAmount"
        },
        {
          title: "额外金额/元",
          align: "center",
          key: "extraAmount"
        },

        {
          title: "规则说明",
          align: "center",
          key: "content"
        }
      ],
      data1: []
    };
  },
  activated: function() {
    this.getData();
  },
  mounted: function() {
    this.getData();
  },

  methods: {
    exportData() {
      this.$refs.table.exportCsv({
        filename: "产品",

        columns: this.columns2.filter((col, index) => {
          return col;
        }),
        data: this.data1.filter((data, index) => {
          return data;
        })
      });
    },
    getData() {
      api
        .ProductSelectAll({
          pageNow: this.pageNow,
          pageSize: "10"
        })
        .then(res => {
          this.data1 = res.body.data.list;

          this.total = res.body.data.total;
          this.data1.forEach(element => {
            element.applyUrl =
              element.applyUrl +
              "?id=" +
              element.id +
              "&userId=" +
              localStorage.getItem("userId") +
              "&v=" +
              Math.random();
            element.rewardAmount = Math.floor(element.rewardAmount / 100);
            element.demotedAmount = Math.floor(element.demotedAmount / 100);
            element.extraAmount = Math.floor(element.extraAmount / 100);
          });
        });
    },
    creatQrCode(row, index) {
      var qrcode = new QRCode(this.$refs["qrCodeUrl" + index], {
        text: row.applyUrl,
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
      setTimeout(() => {
        var img = document
          .getElementById("qrcode" + index)
          .getElementsByTagName("img")[0].src;

        var canvas = document.createElement("canvas");
        canvas.width = 312;
        canvas.height = 556;
        var context = canvas.getContext("2d");
        context.rect(0, 0, canvas.width, canvas.height);
        context.fillStyle = "#fff";
        context.fill();
        var myImage = new Image();
        myImage.src = row.spreadPosters; //背景图片 你自己本地的图片或者在线图片
        // myImage.src = "http://192.168.3.41:8080/img/YTNSOZPZ45823592.ee9eca01.jpg"; //背景图片 你自己本地的图片或者在线图片
        myImage.crossOrigin = "Anonymous";
        myImage.onload = () => {
          context.drawImage(myImage, 0, 0, 312, 556);
          context.font = "60px Courier New";
          var myImage2 = new Image();
          myImage2.src = img; //你自己本地的图片或者在线图片
          myImage2.crossOrigin = "Anonymous";
          myImage2.onload = () => {
            context.drawImage(myImage2, 111, 435, 90, 90);
            var base64 = canvas.toDataURL("image/png"); //"image/png" 这里注意一下

            var img = document.getElementById("base64" + index);

            // document.getElementById('avatar').src = base64;
            img.setAttribute("src", base64);
          };
        };
      }, 500);
    },
    convertCanvasToImage(canvas) {
      var image = new Image();
      image.src = canvas.toDataURL("image/png");
      return image;
    },
    userProductRate() {
      if (this.proportion - 0 > 100) {
        this.proportion = 100;
        this.$layer.alert("代理比例不能超过100%");
      }
      api
        .AddUserProduct({
          productId: this.ConfigData.id,
          rate: this.proportion / 100
        })
        .then(res => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
    },
    Config(row) {
      this.modal1 = true;
      this.proportion = row.userProductRate * 100;
      this.ConfigData = row;
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    }
  }
};
</script>

<style scoped>
.top {
  height: 70px;
  width: 100%;
  position: relative;
  border-bottom: 1px solid #aaa;
  margin-bottom: 20px;
}
.ivu-btn-error {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
.qrcode {
  opacity: 0;
  width: 100px;
  height: 100px;
  margin: 10px auto;
  position: absolute;
  display: none;
}
</style>